const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const UTMIFY_PIXEL_ID = ''

/**
 * Loads the official UTMify UTM tracking script.
 * Safe to call multiple times — the script is injected only once.
 */
export function loadUtmify(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subid', '')
  document.head.appendChild(script)

  if (UTMIFY_PIXEL_ID) {
    const w = window as unknown as { pixelId?: string }
    w.pixelId = UTMIFY_PIXEL_ID
    const pixelScript = document.createElement('script')
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
    pixelScript.async = true
    pixelScript.defer = true
    document.head.appendChild(pixelScript)
  }
}
